import { FormControl, Hidden, InputLabel, MenuItem, Select } from '@material-ui/core';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
    downloadSummaryPDF,
    generateDetailedPDF,
    downloadDetailedPDF,
    getCgsHistory,
    getCgsDocument,
    getCgsDetail,
    getCasHistory,
} from '../../../redux-store/actions/nct';
import { getPortfolio } from '../../../redux-store/actions/portfolio';
import { RootStateType } from '../../../redux-store/reducers';
import {
    ALL_HOLDINGS,
    isMobileDevice,
    NON_ZERO_HOLDINGS,
    ZERO_HOLDINGS,
} from '../../../utils/constants';
import en from '../../../lang/en-us';
import SegmentedControlLarge from '../../common/segemented-control-large';
import SebiCgs from '../cgs';
import SebiCas from '../sebi';

const STATEMENT_SEGMENTS = [
    'Consolidated Account Statement',
    'Consolidated Capital Gains Statement',
];
const { common } = en;

const Statements = (props: any) => {
    const [statementType, setStatementType] = useState(STATEMENT_SEGMENTS[0]);
    const handleSegmentChange = (selectedSegmentIndex: number) => {
        setStatementType(STATEMENT_SEGMENTS[selectedSegmentIndex]);
    };
    return (
        <div className="curved-bg curved-sebi-cas">
            <Hidden smDown={true}>
                <SegmentedControlLarge
                    additionalClasses="portfolio-details-tabs portfolio-demat-tabs"
                    segments={STATEMENT_SEGMENTS}
                    // segmentsSpan={SEGMENTSSPAN}
                    onSegmentChanged={handleSegmentChange}
                    selectedSegmentIndex={STATEMENT_SEGMENTS.findIndex(
                        (str: string) => str === statementType,
                    )}
                    key={statementType}
                />
            </Hidden>
            <Hidden mdUp={true}>
                <FormControl variant="filled">
                    <InputLabel id="holding-type-mobile">Statement Type</InputLabel>
                    <Select
                        labelId="holding-type-mobile"
                        id="holding-type-dropdown"
                        value={statementType}
                        onChange={(e: any) => setStatementType(e.target.value)}
                    >
                        <MenuItem value={STATEMENT_SEGMENTS[0]}>{STATEMENT_SEGMENTS[0]}</MenuItem>
                        <MenuItem value={STATEMENT_SEGMENTS[1]}>{STATEMENT_SEGMENTS[1]}</MenuItem>
                    </Select>
                </FormControl>
            </Hidden>
            {statementType === STATEMENT_SEGMENTS[0] ? (
                <SebiCas {...props} />
            ) : (
                <SebiCgs {...props} />
            )}
        </div>
    );
};

export default connect(
    ({ portfolio, authReducer }: RootStateType) => ({ ...portfolio, ...authReducer }),
    { getPortfolio, downloadSummaryPDF, generateDetailedPDF, downloadDetailedPDF, getCasHistory, getCgsDocument, getCgsDetail, getCgsHistory },
)(Statements);
